import * as React from "react";

const Polygon1SVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1398 869"
    width="100%"
    height="80%"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    {...props}
  >
    <g filter="url(#a)">
      <path
        fill={props.fill}
        fillOpacity={0.12}
        d="m699 809 638.26-916.5H60.74L699 809Z"
      />
    </g>
    <defs>
      <filter
        id="a"
        x="-50%"
        y="-50%"
        width="200%"
        height="200%"
        colorInterpolationFilters="sRGB"
        filterUnits="objectBoundingBox"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_7702_5845"
          stdDeviation={29.9}
        />
      </filter>
    </defs>
  </svg>
);

export default Polygon1SVG;
